/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Flat_Cool_Swan_GlideInputs */

const en_flat_cool_swan_glide = /** @type {(inputs: Flat_Cool_Swan_GlideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter a short description for this version`)
};

const de_flat_cool_swan_glide = /** @type {(inputs: Flat_Cool_Swan_GlideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geben Sie eine kurze Beschreibung für diese Version ein`)
};

/**
* | output |
* | --- |
* | "Enter a short description for this version" |
*
* @param {Flat_Cool_Swan_GlideInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const flat_cool_swan_glide = /** @type {((inputs?: Flat_Cool_Swan_GlideInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Flat_Cool_Swan_GlideInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_flat_cool_swan_glide(inputs)
	return de_flat_cool_swan_glide(inputs)
});